import type { CustomerDashboardView, PaginatedData, TimelineEventView } from '@solar/contracts';

import { apiClient } from '../../lib/api-client';

export const customerDashboardApi = {
  getDashboard(): Promise<CustomerDashboardView> {
    return apiClient.get('/customer/dashboard');
  },

  getTimeline(page = 1, pageSize = 50): Promise<PaginatedData<TimelineEventView>> {
    return apiClient.get(`/customer/timeline?page=${page}&pageSize=${pageSize}`);
  },
};
